import { Send, Instagram, Facebook } from "lucide-react";

const SOCIALS = [
    {
        id: "x",
        name: "X (Twitter)",
        handle: "@spce_100x",
        url: "https://x.com/spce_100x",
        color: "#00F0FF",
        Icon: (props) => (
            <svg
                {...props}
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
            </svg>
        ),
    },
    {
        id: "telegram",
        name: "Telegram",
        handle: "t.me/space_100xchat",
        url: "https://t.me/space_100xchat",
        color: "#00F0FF",
        Icon: (props) => <Send {...props} />,
    },
    {
        id: "tiktok",
        name: "TikTok",
        handle: "@spce_100x",
        url: "https://www.tiktok.com/@spce_100x?_r=1&_t=ZN-97Byxd5FIGs",
        color: "#B026FF",
        Icon: (props) => (
            <svg
                {...props}
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.26Z" />
            </svg>
        ),
    },
    {
        id: "instagram",
        name: "Instagram",
        handle: "@spce_100x",
        url: "https://www.instagram.com/spce_100x?igsh=MTdtZXFuMXI4bHd4ZQ==",
        color: "#B026FF",
        Icon: (props) => <Instagram {...props} />,
    },
    {
        id: "facebook",
        name: "Facebook",
        handle: "SPACE_100X",
        url: "https://www.facebook.com/share/1TmA6uNtjS/",
        color: "#00F0FF",
        Icon: (props) => <Facebook {...props} />,
    },
];

const PUMP_URL =
    "https://pump.fun/coin/4dAwbA1GxBoEMrJPrynPnGViQcJW1NULVB1rTNzbpump";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative pt-24 pb-10 overflow-hidden border-t border-white/10 bg-[#030014]"
        >
            {/* Background gigantic logo */}
            <div
                aria-hidden
                className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
            >
                <span className="font-display font-black tracking-tighter text-white/[0.025] text-[22vw] leading-none">
                    SPACE_100X
                </span>
            </div>
            <div
                aria-hidden
                className="absolute -top-20 left-1/2 -translate-x-1/2 w-[800px] h-[300px] rounded-full bg-[#00F0FF]/10 blur-[140px]"
            />

            <div
                id="mission-control"
                className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8"
            >
                {/* MISSION CONTROL header */}
                <div className="text-center">
                    <div className="font-mono text-xs tracking-[0.3em] uppercase text-[#00F0FF] mb-4">
                        // MISSION CONTROL
                    </div>
                    <h3
                        data-testid="mission-control-title"
                        className="font-display text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase text-white max-w-3xl mx-auto"
                    >
                        Ready for <span className="gradient-text">liftoff</span>?
                    </h3>
                    <p className="mt-6 font-mono text-sm text-slate-400 max-w-xl mx-auto">
                        The launchpad is open. Plug into every channel, follow
                        the crew, and ride SPACE_100X to lunar orbit.
                    </p>

                    {/* Primary CTA */}
                    <div className="mt-10">
                        <a
                            href={PUMP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-buy-button"
                            className="inline-flex items-center gap-2 h-14 px-8 rounded-full bg-[#00F0FF] hover:bg-[#00F0FF]/90 text-black font-display font-black uppercase tracking-tight text-sm shadow-[0_0_28px_rgba(0,240,255,0.45)] hover:shadow-[0_0_44px_rgba(0,240,255,0.7)] transition-all hover:-translate-y-0.5"
                        >
                            Buy on Pump.fun
                        </a>
                    </div>
                </div>

                {/* Social grid */}
                <div className="mt-16">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center gap-3">
                            <span className="h-px w-12 bg-white/20" />
                            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-slate-400">
                                Connect on all channels
                            </span>
                            <span className="h-px w-12 bg-white/20" />
                        </div>
                    </div>

                    <div
                        data-testid="social-grid"
                        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4"
                    >
                        {SOCIALS.map(({ id, name, handle, url, color, Icon }) => (
                            <a
                                key={id}
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`footer-${id}-link`}
                                aria-label={name}
                                className="group relative bg-[#0B0B1A] border border-white/10 rounded-2xl p-5 flex flex-col items-center text-center transition-all hover:-translate-y-1 hover:border-white/30 overflow-hidden"
                                style={{
                                    "--accent": color,
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = `${color}99`;
                                    e.currentTarget.style.boxShadow = `0 0 24px ${color}44, inset 0 0 16px ${color}11`;
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor =
                                        "rgba(255,255,255,0.1)";
                                    e.currentTarget.style.boxShadow = "none";
                                }}
                            >
                                <div
                                    aria-hidden
                                    className="absolute -top-12 left-1/2 -translate-x-1/2 w-28 h-28 rounded-full blur-3xl opacity-0 group-hover:opacity-60 transition-opacity"
                                    style={{ background: color }}
                                />
                                <div
                                    className="relative w-12 h-12 rounded-xl flex items-center justify-center mb-3 border transition-colors"
                                    style={{
                                        background: `${color}15`,
                                        borderColor: `${color}55`,
                                        color,
                                    }}
                                >
                                    <Icon className="w-5 h-5" />
                                </div>
                                <div className="relative font-display text-sm font-bold text-white">
                                    {name}
                                </div>
                                <div className="relative font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500 mt-1 truncate max-w-full">
                                    {handle}
                                </div>
                            </a>
                        ))}
                    </div>
                </div>

                {/* Sub-footer */}
                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                        © {new Date().getFullYear()} SPACE_100X · All systems
                        nominal
                    </div>
                    <div
                        data-testid="footer-disclaimer"
                        className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600 max-w-md"
                    >
                        Memecoin · No financial advice · DYOR before liftoff
                    </div>
                </div>
            </div>
        </footer>
    );
}
